import { Answer, Question, QuestionsTypes } from '../../Types'
import { OptionWrapper } from './OptionWrapper'
import { Nprs11pt2l } from './Nprs11pt2lAnswer'
import { COLOR_PRIMARY } from '../../constants'

type AnswerFactoryProps = {
  question: Question
  answer: Answer
  defaultLang: string
  variant?: 'PRIMARY' | 'SECONDARY'
}
export const AnswerFactory = ({ answer, question, defaultLang, variant = 'PRIMARY' }: AnswerFactoryProps) => {
  const hasValue = !!answer?.value
  const answerIndex = hasValue ? parseInt(answer.value) : null

  if (!hasValue) {
    return null
  }

  const type = question.type
  const variantStyles = {
    primary: { unitClass: 'mb-0', optionClass: 'p-2 me-2 mb-1 border rounded-2 w-100', color: COLOR_PRIMARY },
    secondary: { unitClass: 'mb-0 p-mini', optionClass: 'p-1 me-1 mb-2 border rounded-2', color: '#b5b5b5' },
  }

  const currentVariant = variant === 'PRIMARY' ? variantStyles.primary : variantStyles.secondary

  if (answer.value === 'BLINDED') {
    return (
      <p className="d-inline-block px-3 py-1 p-small rounded-4" style={{ background: '#e6e6e6' }}>
        Value blinded
      </p>
    )
  }

  switch (type) {
    case QuestionsTypes.info:
      return null

    case QuestionsTypes.unitcounter:
      return (
        <div className="border d-inline-block p-2 rounded-3">
          <h6 className={currentVariant.unitClass}>{answer.value}</h6>
        </div>
      )

    case QuestionsTypes.radio:
      // Create and wrap options
      return (
        <div className="d-flex w-100 ">
          {question?.options &&
            question?.options.map((option, questionIndex) => {
              return (
                <OptionWrapper
                  key={`${answerIndex}-${questionIndex}`}
                  isSelected={answerIndex === questionIndex}
                  body={option[defaultLang]}
                  selectedColor={currentVariant.color}
                  className={currentVariant.optionClass}
                />
              )
            })}
        </div>
      )
    case QuestionsTypes.nprs11pt2l:
      // Create and wrap options
      return (
        <Nprs11pt2l
          question={question}
          answerIndex={answerIndex as number}
          defaultLang={defaultLang}
          variant={variant}
        ></Nprs11pt2l>
      )

    default:
      return hasValue ? (
        <div className="d-flex justify-md-content-between justify-content-start">Answer: {answer?.value}</div>
      ) : null
  }
}
